import NetworkIcon from '@liquidweb-dev/undercurrent/icons/lucide/Network';
import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import { type LucideSvgProps } from '@liquidweb-dev/undercurrent/types/svgTypes';
import Typography, {
	type TypographyProps,
} from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

const buildText = (dnsZones: number) => {
	if (dnsZones > 1) {
		return `${dnsZones} DNS zones`;
	}

	if (dnsZones === 1) {
		return '1 DNS zone';
	}

	return 'Not hosted';
};

export interface DnsAttributeProps extends StackProps {
	dnsZones: number;
	iconProps?: LucideSvgProps;
	typographyProps?: TypographyProps;
}

const DnsAttribute = ({
	dnsZones,
	sx,
	iconProps,
	typographyProps,
	...rest
}: DnsAttributeProps) => {
	const hasDns = dnsZones > 0;

	const { sx: iconSx, ...restIconProps } = iconProps || {};
	const { sx: typographySx, ...restTypographyProps } = typographyProps || {};

	return (
		<Stack
			sx={combineSx(
				{
					flexDirection: 'row',
					alignItems: 'center',
					gap: 50,
				},
				sx,
			)}
			{...rest}
		>
			<NetworkIcon
				sx={combineSx(
					({ size, vars }) => ({
						width: size.xS,
						height: size.xS,
						flexShrink: 0,
						color: hasDns
							? vars.palette.uc.highlight.text.main
							: vars.palette.uc.icon.weak,
					}),
					iconSx,
				)}
				{...restIconProps}
			/>
			<Typography
				variant="label-lg"
				sx={combineSx(
					({ vars }) => ({
						fontWeight: 500,
						...(hasDns && { color: vars.palette.uc.highlight.text.main }),
					}),
					typographySx,
				)}
				{...restTypographyProps}
			>
				{buildText(dnsZones)}
			</Typography>
		</Stack>
	);
};

export default DnsAttribute;
